import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-component-state',
    templateUrl: './component-state.component.html',
    styleUrls: ['./component-state.component.scss']
})
export class ComponentStateComponent implements OnInit {

    @Input() name = '';
    @Input() validity = false;
    @Input() value: any = null;

    constructor() {
    }

    ngOnInit(): void {
    }

    determineValue() {
        if (this.value) {
            return JSON.stringify(this.value);
        }

        return "";
    }
}
